import React from "react";
import Card from "./Card";
import SectionHeading from "./SectionHeading";
import { FaBrain } from "react-icons/fa";
import { GiPuzzle, GiHexagonalNut } from "react-icons/gi";

const featureData = [
  {
    id: 1,
    icon: <FaBrain />,
    title: "Memorability",
    subtitle:
      "Is your domain short and easy to remember? The simpler and more memorable it is, the higher its value.",
    review: "100 plus Reviews",
  },
  {
    id: 2,
    icon: <GiPuzzle />,
    title: "Global Appeal",
    subtitle:
      "Does your domain work well internationally? A domain that functions globally is often more valuable.",
    review: "100 plus Reviews",
  },
  {
    id: 3,
    icon: <GiHexagonalNut />,
    title: "Advertising Power",
    subtitle:
      "Can your domain shine in marketing campaigns? Names with strong advertising potential usually command a higher worth.",
    review: "100 plus Reviews",
  },
];

const Featured = () => {
  const heading = {
    headingOne: "Domain Appraisals: ",
    headingTwo: "The Strategy",
    describe:
      "Unlocking Domain Worth: A Comprehensive Analysis for Maximum Appraisal",
  };

  return (
    <div className=" mx-auto a-container px-3 py-5 featured-section flex justify-center items-center">
      <div className="container a-container  pt-[140px]">
        <SectionHeading heading={heading} />
        <div className="row g-3">
          {featureData.map((data) => (
            <div className="col-12 col-md-6 col-lg-4" key={data.id}>
              <Card data={data} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Featured;
